module.exports = __webpack_public_path__ + "static/media/dev-9.edd3cbbb.png";